import React from 'react'
import { history } from '../store'
import * as dateFormat from 'dateformat'

import IncidenceStatusBadge from './IncidenceStatusBadge'
import IncidenceCategoryBadge from './IncidenceCategoryBadge'
import IncidenceTimeBadge from './IncidenceTimeBadge'

class IncidenceOpenList extends React.Component {
  goTo(number, e) {
    history.push(`/incidences/${number}`)
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Fecha Apertura</th>
              <th scope="col">Cliente</th>
              <th scope="col">Máquina</th>
              <th scope="col">Categoria</th>
              <th scope="col">Max Tiempo Respuesta</th>
              <th scope="col">Max Tiempo Reparación</th>
              <th scope="col">Tiempo Transcurrido</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            {this.props.incidences.map(incidence => {
              const saleDate = new Date(incidence.createdAt);
              saleDate.setHours(saleDate.getHours() - 2);
              const formattedDate = `${saleDate.getDate()}/${saleDate.getMonth() + 1}/${saleDate.getFullYear()} ${saleDate.getHours().toString().padStart(2, '0')}:${saleDate.getMinutes().toString().padStart(2, '0')}`;

              const OpendateNoformat = new Date(incidence.createdAt)

              const currentDate = new Date();
              const transcurredTime = currentDate.getTime() - OpendateNoformat.getTime();
              const hourDiff = Math.floor(transcurredTime / (1000 * 60 * 60)); // Get the number of whole hours
              const minuteDiff = Math.floor((transcurredTime / (1000 * 60)) % 60); // Get the number of remaining minutes

              if (incidence.Status !== "CLOSED") {
                return (
                  <tr key={incidence.number}
                    onClick={e => this.goTo(incidence.number, e)}>
                    <th scope="row">{incidence.number}</th>
                    <td>{formattedDate}</td>
                    <td>{incidence.Customer.Fullname}</td>
                    <td>{incidence.Machine.Serial}</td>
                    <td>
                      <IncidenceCategoryBadge category={incidence.Category} />
                    </td>
                    <td>{incidence.ResponseForecastTime}h</td>
                    <td>{incidence.RepairingForecastTime}h</td>
                    <td>
                      <IncidenceTimeBadge hourDiff={hourDiff} minuteDiff={minuteDiff} openDate={formattedDate} compareTime={incidence.RepairingForecastTime} category={incidence.Category}/>
                    </td>
                    <td>
                      <IncidenceStatusBadge status={incidence.Status} />
                    </td>
                  </tr>
                )
              }
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default IncidenceOpenList

